import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "dismissOnClick"],
  _excluded2 = ["placement", "trigger", "label", "inline", "floatingArrow", "arrowIcon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, useMemo, useState } from 'react';
import { HiOutlineChevronDown, HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineChevronUp } from 'react-icons/hi';
import { uuid } from '../../helpers/uuid';
import { Button } from '../Button';
import { Floating } from '../Floating';
import { useTheme } from '../Flowbite/ThemeContext';
import { DropdownDivider } from './DropdownDivider';
import { DropdownHeader } from './DropdownHeader';
import { DropdownItem } from './DropdownItem';
var icons = {
  top: HiOutlineChevronUp,
  right: HiOutlineChevronRight,
  bottom: HiOutlineChevronDown,
  left: HiOutlineChevronLeft
};
var DropdownComponent = function DropdownComponent(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$dismissOnClick = _ref.dismissOnClick,
    dismissOnClick = _ref$dismissOnClick === void 0 ? true : _ref$dismissOnClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.dropdown;
  var theirProps = props;
  var _theirProps$placement = theirProps.placement,
    placement = _theirProps$placement === void 0 ? props.inline ? 'bottom-start' : 'bottom' : _theirProps$placement,
    _theirProps$trigger = theirProps.trigger,
    trigger = _theirProps$trigger === void 0 ? 'click' : _theirProps$trigger,
    label = theirProps.label,
    inline = theirProps.inline,
    _theirProps$floatingA = theirProps.floatingArrow,
    floatingArrow = _theirProps$floatingA === void 0 ? false : _theirProps$floatingA,
    _theirProps$arrowIcon = theirProps.arrowIcon,
    arrowIcon = _theirProps$arrowIcon === void 0 ? true : _theirProps$arrowIcon,
    buttonProps = _objectWithoutProperties(theirProps, _excluded2);
  var Icon = useMemo(function () {
    var _icons$p;
    var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 1),
      p = _placement$split2[0];
    return (_icons$p = icons[p]) !== null && _icons$p !== void 0 ? _icons$p : HiOutlineChevronDown;
  }, [placement]);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    closeRequestKey = _useState2[0],
    setCloseRequestKey = _useState2[1];
  // Extends DropdownItem's onClick to trigger a close request to the Floating component
  var attachCloseListener = function attachCloseListener(node) {
    if (!React.isValidElement(node)) return node;
    if (node.type === DropdownItem) return React.cloneElement(node, {
      onClick: function onClick() {
        var _node$props$onClick, _node$props;
        (_node$props$onClick = (_node$props = node.props).onClick) === null || _node$props$onClick === void 0 ? void 0 : _node$props$onClick.call(_node$props);
        dismissOnClick && setCloseRequestKey(uuid());
      }
    });
    if (node.props.children && typeof node.props.children === 'object') {
      return React.cloneElement(node, {
        // @ts-ignore
        children: Children.map(node.props.children, attachCloseListener)
      });
    }
    return node;
  };
  var content = useMemo(function () {
    return _jsx("ul", {
      className: theme.content,
      children: Children.map(children, attachCloseListener)
    });
  }, [children, theme]);
  var TriggerWrapper = function TriggerWrapper(_ref2) {
    var children = _ref2.children;
    return inline ? _jsx("button", {
      className: theme.inlineWrapper,
      children: children
    }) : _jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      children: children
    }));
  };
  return _jsx(Floating, {
    content: content,
    style: "auto",
    animation: "duration-100",
    placement: placement,
    arrow: floatingArrow,
    trigger: trigger,
    theme: theme.floating,
    closeRequestKey: closeRequestKey,
    className: className,
    children: _jsxs(TriggerWrapper, {
      children: [label, arrowIcon && _jsx(Icon, {
        className: theme.arrowIcon
      })]
    })
  });
};
DropdownComponent.displayName = 'Dropdown';
DropdownItem.displayName = 'Dropdown.Item';
DropdownHeader.displayName = 'Dropdown.Header';
DropdownDivider.displayName = 'Dropdown.Divider';
export var Dropdown = Object.assign(DropdownComponent, {
  Item: DropdownItem,
  Header: DropdownHeader,
  Divider: DropdownDivider
});